import { Injectable } from '@angular/core';
import { RULES } from '../../auth/Roles';
import { LocalStorage } from '../../wrappers/LocalStorage';

export interface BadgeItem {
    type: string;
    value: string;
}

export interface ChildrenItems {
    state: string;
    target?: boolean;
    name: string;
    type?: string;
    children?: ChildrenItems[];
}

export interface MainMenuItems {
    state: string;
    main_state?: string;
    target?: boolean;
    name: string;
    type: string;
    icon: string;
    badge?: BadgeItem[];
    children?: ChildrenItems[];
    show: boolean;
}

export interface Menu {
    label: string;
    main: MainMenuItems[];
}


const showItems = (path) => {
    let localStorage = new LocalStorage();
    const user = localStorage.retrieve('user');
    if (user) {
        let resources = Object.keys(RULES[user.permission].resources);

        if (resources.includes(path))
            return true;

        return false;
    }

    return true;
};

let MENUITEMS = [
    {
        label: 'Home',
        main: [
            {
                state: 'home',
                name: 'Home',
                type: 'link',
                icon: 'icon-home',
                show: true,
            },
            {
                state: 'dashboard',
                name: 'Dashboard',
                type: 'link',
                icon: 'fa fa-dashboard',
                show: showItems('dashboard'),
            },
            {
                state: 'billing-letter',
                name: 'Cartas de Faturamento',
                type: 'sub',
                icon: 'icon-wallet',
                show: showItems('billing-letter'),
                children: [
                    {
                        state: '',
                        name: 'Listagem',
                    },
                    {
                        state: 'new',
                        name: 'Nova Carta',
                    },
                ],
            },
            {
                state: 'accounting-block',
                name: 'Período Contábil',
                type: 'link',
                icon: 'fa fa-lock',
                show: showItems('accounting-block'),
            },
            {
                state: 'approvals',
                name: 'Aprovações',
                type: 'sub',
                icon: 'icon-check',
                show: showItems('approvals'),
                children: [
                    {
                        state: '',
                        name: 'Listagem',
                    },
                    {
                        state: 'new',
                        name: 'Nova Aprovação',
                    },
                    {
                        state: 'approvals-upload',
                        name: 'Carga Aprovação',
                    },
                ],
            },
            {
                state: 'refunds',
                name: 'Reembolsos',
                type: 'link',
                icon: 'icon-wallet',
                show: showItems('refunds'),
            },
            {
                state: 'purchase-orders',
                name: 'Pedidos de compra',
                type: 'sub',
                icon: 'icon-credit-card',
                show: showItems('purchase-orders'),
                children: [
                    {
                        state: '',
                        name: 'Listagem',
                    },
                    {
                        state: 'new',
                        name: 'Novo Pedido',
                    },
                    {
                        state: 'hierarchy',
                        name: 'Gerenciamento de alçada',
                    },
                ],
            },
            {
                state: 'companies',
                name: 'Empresas',
                type: 'sub',
                icon: 'icon-briefcase',
                show: showItems('companies'),
                children: [
                    {
                        state: '',
                        name: 'Listagem',
                    },
                    {
                        state: 'new',
                        name: 'Nova Empresa',
                    },
                    {
                        state: 'group',
                        name: 'Grupo',
                    },
                    {
                        state: 'company-inventory',
                        name: 'Gestão de Inventários',
                    },
                    {
                        state: 'vendor-inventory',
                        name: 'Gestão de Fornecedores',
                    },

                ],
            },
            {
                state: 'projects',
                name: 'Projetos',
                type: 'link',
                icon: 'icon-notebook',
                show: showItems('projects')
            },
            {
                state: 'cnaes',
                name: 'Cnaes e Itens',
                type: 'sub',
                icon: 'icon-list',
                show: showItems('cnaes'),
                children: [
                    {
                        state: '',
                        name: 'Listagem',
                    },
                    {
                        state: 'new',
                        name: 'Novo Cnae/Item',
                    },
                ],
            },
            {
                state: 'consultants',
                name: 'Consultores',
                type: 'sub',
                icon: 'icon-people',
                show: showItems('consultants'),
                children: [
                    {
                        state: '',
                        name: 'Listagem',
                    },
                    {
                        state: 'archives',
                        name: 'Histórico',
                    },
                ],
            },
            {
                state: 'reports',
                name: 'Relatórios',
                type: 'sub',
                icon: 'icon-chart',
                show: showItems('reports'),
                children: [
                    {
                        state: 'consultant',
                        name: 'Consultor',
                    },
                ],
            },
            {
                state: 'log',
                name: 'Registros de Atividade',
                type: 'sub',
                icon: 'icon-book-open',
                show: showItems('log'),
                children: [
                    {
                        state: '',
                        name: 'Listagem',
                    },
                ],
            },
            {
                state: 'users',
                name: 'Usuários',
                type: 'sub',
                icon: 'icon-user',
                show: showItems('users'),
                children: [
                    {
                        state: '',
                        name: 'Listagem',
                    },
                    {
                        state: 'new',
                        name: 'Novo Usuário',
                    },
                ],
            },
        ],
    },
];

@Injectable()
export class MenuItems {
    getAll(): Menu[] {
        MENUITEMS[0].main = MENUITEMS[0].main.filter(item => item.show == true);
        return MENUITEMS;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/menu-items/menu-items.ts